export default "__VITE_ASSET__BUC$3NaS__"